// Status de Pagamento do Safe2Pay Obs.:(O id do enum se refere a coluna idSafe2Pay da tabela StatusPagamento)
export enum StatusPagamentoEnum {
    Nenhum = 0,
    NenhumDescription = 'Nenhum',
    Pendente = 1,
    PendenteDescription = 'Pendente',
    Processamento = 2,
    ProcessamentoDescription = 'Processamento',
    Autorizado = 3,
    AutorizadoDescription = 'Autorizado',
    Disponivel = 4,
    DisponivelDescription = 'Disponível',
    EmDisputa = 5,
    EmDisputaDescription = 'Em disputa',
    Devolvido = 6,
    DevolvidoDescription = 'Devolvido',
    Baixado = 7,
    BaixadoDescription = 'Baixado',
    Recusado = 8,
    RecusadoDescription = 'Recusado',
    Liberado = 11,
    LiberadoDescription = 'Liberado',
    EmCancelamento = 12,
    EmCancelamentoDescription = 'Em Cancelamento',
    Chargeback = 13,
    ChargebackDescription = 'Chargeback'
}

export namespace StatusPagamentoEnum {
    export function values() {
        return Object.keys(StatusPagamentoEnum)
            .filter((type) => isNaN(<any>type) && type !== 'values' && !type.includes('Description') && !type.includes('Nenhum'))
            .map(item => {
                return { nomeItem: item, enum: +StatusPagamentoEnum[item], description: (StatusPagamentoEnum[item + 'Description']).split(';')[0] };
            });
    }
}
